export enum PaymentStatusesEnum {
    AttemptingAuthorize = 'AttemptingAuthorize',
    Authorized = 'Authorized',
    FailedAuthorize = 'FailedAuthorize',
    AttemptingCapture = 'AttemptingCapture',
    Captured = 'Captured',
    FailedCapture = 'FailedCapture',
    Requested = 'Requested',
    Adjustment = 'Adjustment'

  }